import { FLEXIBLE_NIGHTS_MIN, FLEXIBLE_NIGHTS_MAX } from '@constants'
import { parseDateString, normalizeDateToMidnight } from '@utils/dateUtils'
import type { MkSearchConstraintsResponse } from '../services/searchTypes'

/** Mapped constraints for date picker (flexi + specific). Fallbacks when API values missing/invalid. */
export interface SearchConstraints {
  maxBookingMonths: number
  minimumNights: number
  maximumNights: number
}

/** Default constraints when search constraints API fails or returns no data. Normalize brand (ev → ebac, lowercase). */
export function getDefaultSearchConstraints(brand: string): SearchConstraints {
  const b = (brand ?? '').trim().toLowerCase()
  if (b === 'ebac') {
    return { minimumNights: 1, maximumNights: 30, maxBookingMonths: 13 }
  }
  return { minimumNights: 2, maximumNights: 28, maxBookingMonths: 14 }
}

export function mapSearchConstraintsResponse(res: MkSearchConstraintsResponse, maxStayMonths: number): SearchConstraints {
  const today = normalizeDateToMidnight(new Date())
  let maxBookingMonths = maxStayMonths
  if (res.maximumCheckInDate) {
    const maxDate = parseDateString(res.maximumCheckInDate)
    if (maxDate && maxDate >= today) {
      const months = (maxDate.getFullYear() - today.getFullYear()) * 12 + (maxDate.getMonth() - today.getMonth())
      if (months >= 1 && months <= 60) maxBookingMonths = months
    }
  }
  const minimumNights = Number.isFinite(res.minimumNights) && res.minimumNights >= 1 ? res.minimumNights : FLEXIBLE_NIGHTS_MIN
  const maximumNights = Number.isFinite(res.maximumNights) && res.maximumNights >= minimumNights ? res.maximumNights : FLEXIBLE_NIGHTS_MAX
  return { maxBookingMonths, minimumNights, maximumNights }
}
